/**
 * BÖY SAUCE — L'escalier : accompagnement de la navigation entre formats.
 *
 * Depuis le 07/09, chaque palier porte deux gestes : un lien vers la vraie fiche
 * du format, et un bouton d'ajout au panier géré par boy-add.js. Ce module-ci ne
 * s'occupe QUE du lien, et ne fait que deux choses, dont aucune ne peut casser
 * l'achat s'il ne se charge pas :
 *
 *   1. il précharge la fiche visée dès que le doigt touche le palier, pour que
 *      la bascule soit quasi instantanée sur mobile ;
 *   2. il marque le palier touché comme « en cours » pour que le retour visuel
 *      précède le changement de page.
 *
 * Fichier custom BÖY — ne fait pas partie de Savor.
 */
const prefetched = new Set();

function prefetch(url) {
  if (!url || prefetched.has(url)) return;
  prefetched.add(url);
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.as = 'document';
  link.href = url;
  document.head.appendChild(link);
}

function track(tier, bottles) {
  const payload = { event: 'boy_tier_click', tier, bottles, surface: 'pdp' };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  document.dispatchEvent(new CustomEvent('boy_tier_click', { detail: payload }));
}

document.querySelectorAll('.boy-esc__link').forEach((link) => {
  if (link.getAttribute('aria-current') === 'page') return;

  const warm = () => prefetch(link.href);
  link.addEventListener('pointerenter', warm, { once: true });
  link.addEventListener('touchstart', warm, { once: true, passive: true });

  link.addEventListener('click', () => {
    link.setAttribute('data-boy-pending', '');
    track(link.dataset.boyTier, Number(link.dataset.bottles) || null);
  });
});
